/* Kocktail PDP — progressive enhancement for the buy box.
   Core add-to-cart works without JS (native form POST to /cart/add);
   this only adds the quantity stepper and live price on variant change. */
(function () {
  function initQty(root) {
    root.querySelectorAll('[data-kx-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('.kx-qty__i');
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      var clamp = function (n) { return Math.max(min, Math.min(max, n)); };
      var step = function (d) { input.value = clamp((parseInt(input.value, 10) || min) + d); };
      wrap.querySelector('[data-kx-qty-dn]')?.addEventListener('click', function () { step(-1); });
      wrap.querySelector('[data-kx-qty-up]')?.addEventListener('click', function () { step(1); });
      input.addEventListener('change', function () {
        var n = parseInt(input.value, 10);
        input.value = isNaN(n) ? min : clamp(n);
      });
    });
  }

  function initVariantPrice(root) {
    var priceEl = root.querySelector('[data-kx-price]');
    if (!priceEl) return;
    root.querySelectorAll('[data-kx-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked && radio.dataset.price) priceEl.textContent = radio.dataset.price;
      });
    });
  }

  /* The gift add-on only fits part of the range, so it appears and disappears
     with the selected variant. Hiding it is not enough on its own: a ticked
     box left checked behind display:none still submits, and the customer pays
     for a box that does not fit the bottle they just switched to. It is
     cleared on the way out. */
  function initGiftEligibility(root) {
    var gift = root.querySelector('[data-kx-gift-match]');
    if (!gift) return;
    var match = (gift.getAttribute('data-kx-gift-match') || '').trim().toLowerCase();
    if (!match) return;

    function apply(title) {
      var ok = (title || '').toLowerCase().indexOf(match) !== -1;
      gift.classList.toggle('is-hidden', !ok);
      if (!ok) {
        var box = gift.querySelector('input[type="checkbox"]');
        if (box && box.checked) {
          box.checked = false;
          box.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    root.querySelectorAll('[data-kx-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio.dataset.title);
      });
    });
    var checked = root.querySelector('[data-kx-variant]:checked');
    if (checked) apply(checked.dataset.title);
  }

  function init() {
    var pdp = document.querySelector('.kx-pdp');
    if (!pdp) return;
    initQty(pdp);
    initVariantPrice(pdp);
    initGiftEligibility(pdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
